

























































































 import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
 import Util from '@/lib/util'
 import AbpBase from '@/lib/abpbase'
 import PageRequest from '@/store/entities/page-request'
 import AppConsts from '@/lib/appconst';
import _ from 'lodash'
 class  PageBinRequest extends PageRequest{
     keyword:string;
     type: string;
     roomCode: string;
     aisleCode: string;
     level:number=null; 
 }

 @Component
 export default class Bin extends  AbpBase{
     pagerequest:PageBinRequest=new PageBinRequest();
     items=[];
     pageSize = AppConsts.pageSize;
     currentPage = 1;
     selectedLocationIds=[];
     get store() {
       return this.$store.state.locationLocking;
     }
    
     get loading() {
       return this.store.loading;
     }
    
     get totalCount() {
       return Util.isNull(this.items)?0: this.items.length;
     }
     get binTypes()
     {
         return this.$store.state.bin.binTypes;
     }
     get rooms()
     {
         var rooms = this.$store.state.bin.rooms;
         this.pagerequest.roomCode = Util.isNull(rooms) || rooms.length<=0?'': rooms[0].id;
         return rooms;
     }
     get aisles()
     {
         var aisles = this.$store.state.bin.aisles;
         this.pagerequest.aisleCode = Util.isNull(aisles) || aisles.length<=0?'': aisles[0].id;
         return aisles;
     }
     pageChange(page: number) {
       this.currentPage = page;
     }
     pagesizeChange(pagesize: number) {
       this.pageSize=pagesize;
     }
     async searchBins() {
         await this.$store.dispatch({
             type:'locationLocking/searchBins',
             data: this.pagerequest
         }).then(re=>
         {
             this.items = re.items;
         });
     }
     get list(){
       return Util.pagingItems(this.items,this.pageSize,this.currentPage);
     }
    
     onSelect (selection, row) {
       this.$emit('on-select', selection, row)
     }
     onSelectCancel (selection, row) {
       this.$emit('on-select-cancel', selection, row)
     }
     onSelectAll (selection) {
       this.$emit('on-select-all', selection)
     }
     onSelectionChange (selection) {
       this.$emit('on-selection-change', selection)
       _.forEach(this.list, (o) => {
         var itemSelected = _.find(selection, function (x) { return x.id === o.id });
         if(itemSelected){
           o._checked = true;
         }else{
           o._checked = false;
         }
       });
         var selectedItems = this.items.filter((item) =>  item._checked);
         this.selectedLocationIds = _.map(selectedItems,'id');
         this.$emit('update:selectedLocationIds', this.selectedLocationIds)
     }
     columns= [
           {
               type: 'selection',
               width: 60,
               align: 'center',
               key:'selected'
           },
           {
               title:Util.L('Code'),
               width: 200,
               key:'code'
           },
           {
               title:Util.L('Type'),
               width: 150,
               key:'typeName'
           },
           {
               title:Util.L('Room'),
               key:'roomCode'
           },
            {
               title:Util.L('Aisle'),
               key:'aisleCode'
           },
            {
               title:Util.L('Level'),
               key:'level'
           },
           {
               title:Util.L('AllocatedQty'),
               key:'allocatedQty',
               align:"right",
               render:(h:any,params:any)=>{
                   if(Util.isNull(params.row.allocatedQty))
                   return '0';
                   return h("span", Util.toViewNumberString(params.row.allocatedQty));
               }
           }
       ]
    created(){
     }
     searchBinsRule = {
         roomCode: [
             {
                 required: true,
                 message: this.L("Error.RequiredField", undefined, this.L("Room")),
                 trigger: "blur"
             }
         ],
         aisleCode: [
             {
                 required: true,
                 message: this.L("Error.RequiredField", undefined, this.L("Aisle")),
                 trigger: "blur"
             }
         ]        };
 }
